import React from "react";

// Elements
import CaseStudy1 from "../elements/case-study-1";
import CaseStudy2 from "../elements/case-study-2";
import LatestNewsSection from "../elements/latest-news-slider";
import { joinLinkedInGroup } from "../elements/linkedInGroupCTA";
import MainBannerSection from "../elements/main-banner";
import OurTeam from "../elements/our-team";
import { PartnersSection } from "../elements/partnersSection";
import ServicesSliderSection from "../elements/services-slider";
import TestimonialSection from "../elements/testimonial";
import { Contact } from "./contact-widget";

function Index() {
  return (
    <>
      <MainBannerSection />
      <PartnersSection />
      <ServicesSliderSection />

      <CaseStudy1 />
      <CaseStudy2 />

      <TestimonialSection />
      <OurTeam />

      <LatestNewsSection />
      <h2
        style={{
          textAlign: "center",
          paddingBottom: "200px",
        }}
      >
        Contact Us
      </h2>
      {Contact()}

      {joinLinkedInGroup}
    </>
  );
}

export default Index;
